module.exports = __webpack_public_path__ + "img/personal-center-slide-blue.0a67373f.svg";